import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/mcm-registrazione-ddt/:agentId',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "MCM Registrazione DDT"] },
    }, {
        path: '/agents/mcm-registrazione-ddt/:agentId/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "MCM Registrazione DDT", "Conversazione"] },
    }]
}]

export default routes;